<div class="table-title">
    <ng-container>
        <span class="sectionTitle" stylePreference [textColor]="textColor">
            {{ sectionTitle }}
        </span>
    </ng-container>
    <mat-icon class="edit-icon" (click)="editSectionTitle()" svgIcon="aumico-pattern-icon-edit-write"></mat-icon>
</div>
<div class="{{ markerClasses.BALANCE }}">
    <div [ngClass]="{ Group: options === undefined ? false : options.displayAssetsAndLiabilitiesInSamePage }">
        <ng-container *ngFor="let sectionTable of sectionData; index as i">
            <div
                [ngClass]="{ subGroup: options === undefined ? false : options.displayAssetsAndLiabilitiesInSamePage }"
            >
                <table
                    style="width: 100%"
                    [ngClass]="{
                        'page-break-after-in-print':
                            reportType === 'balance' && i !== lastSectionIndex && !disableBalanceSheetPageBreak
                    }"
                >
                    <ng-container *ngFor="let row of sectionTable">
                        <ng-container *ngIf="row.rowType === 'EmptyRow'">
                            <tr class="empty-row"></tr>
                        </ng-container>
                        <ng-container *ngIf="row.rowType === 'TableHead'">
                            <thead>
                                <tr
                                    [style.color]="tableHeaderColor"
                                    class="big-row-min-height_plus-border-height black-border-down header"
                                >
                                    <th class="title text-align-bottom">
                                        {{ row.t }}
                                    </th>
                                    <th class="notes text-align-bottom" *ngIf="showNotes">{{ row.r }}</th>
                                    <th
                                        class="value text-align-bottom"
                                        [attr.colspan]="options.printClosingValueTotalsInSeparateColumn ? 2 : 1"
                                        [style.background-color]="backgroundColor"
                                    >
                                        {{ row.cV }}
                                    </th>
                                    <!-- FX twin: always ONE body cell per row — never the
                                         separate-totals colspan of the functional column -->
                                    <th
                                        *ngIf="isFxFormat"
                                        class="value text-align-bottom"
                                        [style.background-color]="backgroundColor"
                                    >
                                        {{ row.cV2 }}
                                    </th>
                                    <th
                                        class="ratios text-align-bottom"
                                        *ngIf="showRatios"
                                        [style.background-color]="backgroundColor"
                                    >
                                        {{ row.cP }}
                                    </th>
                                    <th
                                        class="value text-align-bottom"
                                        *ngIf="!noPreviousData"
                                        [style.background-color]="backgroundColorPY"
                                    >
                                        {{ row.pV }}
                                    </th>
                                    <th
                                        class="value text-align-bottom"
                                        *ngIf="!noPreviousData && isFxFormat"
                                        [style.background-color]="backgroundColorPY"
                                    >
                                        {{ row.pV2 }}
                                    </th>
                                    <th
                                        class="ratios text-align-bottom"
                                        *ngIf="!noPreviousData && showRatios"
                                        [style.background-color]="backgroundColorPY"
                                    >
                                        {{ row.pP }}
                                    </th>
                                </tr>
                            </thead>
                        </ng-container>
                        <ng-container *ngIf="row.rowType === 'GroupHeader'">
                            <tr
                                [ngClass]="
                                    row.disableNumbering ? 'indent-level-' + row.level : 'counter-level-' + row.level
                                "
                                [style.color]="tableHeaderColor"
                                class="row-min-height_plus-border-height big-row-min-height_plus-border-height ng-star-inserted"
                            >
                                <td class="title row-min-height black-border-down big-row-min-height text-align-top">
                                    <div [class]="'format-level-' + row.level" class="text-cell">
                                        <span [class]="'title-text-' + row.level + ' indentation-' + row.level"></span>
                                        <span>
                                            {{ row.t }}
                                        </span>
                                    </div>
                                </td>
                                <td class="notes black-border-down big-row-min-height" *ngIf="showNotes"></td>
                                <td
                                    [ngClass]="options.printClosingValueTotalsInSeparateColumn ? 'value-half' : 'value'"
                                    class="black-border-down big-row-min-height"
                                    *ngIf="options.printClosingValueTotalsInSeparateColumn"
                                    [style.background-color]="backgroundColor"
                                ></td>
                                <td
                                    [ngClass]="options.printClosingValueTotalsInSeparateColumn ? 'value-half' : 'value'"
                                    class="black-border-down big-row-min-height"
                                    [style.background-color]="backgroundColor"
                                ></td>
                                <td
                                    class="value black-border-down big-row-min-height"
                                    *ngIf="isFxFormat"
                                    [style.background-color]="backgroundColor"
                                ></td>
                                <td
                                    class="ratios black-border-down big-row-min-height"
                                    *ngIf="showRatios"
                                    [style.background-color]="backgroundColor"
                                ></td>

                                <td
                                    class="value black-border-down big-row-min-height"
                                    *ngIf="!noPreviousData"
                                    [style.background-color]="backgroundColorPY"
                                ></td>
                                <td
                                    class="value black-border-down big-row-min-height"
                                    *ngIf="!noPreviousData && isFxFormat"
                                    [style.background-color]="backgroundColorPY"
                                ></td>
                                <td
                                    class="ratios black-border-down big-row-min-height"
                                    *ngIf="!noPreviousData && showRatios"
                                    [style.background-color]="backgroundColorPY"
                                ></td>
                            </tr>
                        </ng-container>
                        <ng-container *ngIf="row.rowType === 'HeaderRow'">
                            <tr
                                [ngClass]="'indent-level-' + row.level"
                                [style.color]="tableHeaderColor"
                                class="row-min-height_plus-border-height gray-border-down"
                            >
                                <td class="title text-align-top">
                                    <div class="text-cell bolder-bigger">
                                        <span>{{ row.t }}</span>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                        <ng-container
                            *ngIf="row.rowType === 'Row' || row.rowType === 'SubRow' || row.rowType === 'Acc'"
                        >
                            <tr
                                [ngClass]="
                                    row.disableNumbering ? 'indent-level-' + row.level : 'counter-level-' + row.level
                                "
                                [style.color]="textColor"
                                class="row-min-height_plus-border-height gray-border-down"
                            >
                                <td class="title text-align-top">
                                    <div [class]="'format-level-' + row.level" class="text-cell">
                                        <span [class]="'title-text-' + row.level + ' indentation-' + row.level"></span>
                                        <span>{{ row.t }}</span>
                                    </div>
                                </td>
                                <td class="notes text-align-top" *ngIf="showNotes">{{ row.r }}</td>
                                <td
                                    class="text-align-top"
                                    [ngClass]="options.printClosingValueTotalsInSeparateColumn ? 'value-half' : 'value'"
                                    *ngIf="options.printClosingValueTotalsInSeparateColumn"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cF }}
                                </td>
                                <td
                                    class="text-align-top"
                                    [ngClass]="options.printClosingValueTotalsInSeparateColumn ? 'value-half' : 'value'"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cV }}
                                </td>
                                <td
                                    *ngIf="isFxFormat"
                                    class="text-align-top"
                                    [ngClass]="options.printClosingValueTotalsInSeparateColumn ? 'value-half' : 'value'"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cV2 }}
                                </td>

                                <td
                                    class="ratios text-align-top"
                                    *ngIf="showRatios"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cP }}
                                </td>
                                <td
                                    class="value text-align-top"
                                    *ngIf="!noPreviousData"
                                    [style.background-color]="backgroundColorPY"
                                >
                                    {{ row.pV }}
                                </td>
                                <td
                                    class="value text-align-top"
                                    *ngIf="!noPreviousData && isFxFormat"
                                    [style.background-color]="backgroundColorPY"
                                >
                                    {{ row.pV2 }}
                                </td>
                                <td
                                    class="ratios text-align-top"
                                    *ngIf="!noPreviousData && showRatios"
                                    [style.background-color]="backgroundColorPY"
                                >
                                    {{ row.pP }}
                                </td>
                            </tr>
                        </ng-container>
                        <ng-container *ngIf="row.rowType === 'Of'">
                            <tr
                                [ngClass]="'bullet-level-' + row.level"
                                [style.color]="textColor"
                                class="row-min-height_plus-border-height gray-border-down"
                            >
                                <td class="title text-align-top">
                                    <div class="text-cell">
                                        <span [class]="'title-text-' + row.level + ' indentation-' + row.level"></span>
                                        <span>
                                            {{ row.t }}
                                        </span>
                                    </div>
                                </td>
                                <td class="notes text-align-top" *ngIf="showNotes">{{ row.r }}</td>
                                <td
                                    class="text-align-top"
                                    [ngClass]="options.printClosingValueTotalsInSeparateColumn ? 'value-half' : 'value'"
                                    *ngIf="options.printClosingValueTotalsInSeparateColumn"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cF }}
                                </td>
                                <td
                                    class="text-align-top"
                                    [ngClass]="options.printClosingValueTotalsInSeparateColumn ? 'value-half' : 'value'"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cV }}
                                </td>
                                <td
                                    *ngIf="isFxFormat"
                                    class="text-align-top"
                                    [ngClass]="options.printClosingValueTotalsInSeparateColumn ? 'value-half' : 'value'"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cV2 }}
                                </td>

                                <td
                                    class="ratios text-align-top"
                                    *ngIf="showRatios"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cP }}
                                </td>
                                <td
                                    class="value text-align-top"
                                    *ngIf="!noPreviousData"
                                    [style.background-color]="backgroundColorPY"
                                >
                                    {{ row.pV }}
                                </td>
                                <td
                                    class="value text-align-top"
                                    *ngIf="!noPreviousData && isFxFormat"
                                    [style.background-color]="backgroundColorPY"
                                >
                                    {{ row.pV2 }}
                                </td>
                                <td
                                    class="ratios text-align-top"
                                    *ngIf="!noPreviousData && showRatios"
                                    [style.background-color]="backgroundColorPY"
                                >
                                    {{ row.pP }}
                                </td>
                            </tr>
                        </ng-container>
                        <ng-container *ngIf="row.rowType === 'RowTotal'">
                            <tr
                                [style.color]="tableFooterColor"
                                class="row-min-height_plus-border-height gray-border-down"
                            >
                                <td class="title text-align-top">
                                    <span>{{ row.t }}</span>
                                </td>
                                <td class="notes text-align-top" *ngIf="showNotes">{{ row.r }}</td>
                                <td
                                    class="text-align-top"
                                    [ngClass]="options.printClosingValueTotalsInSeparateColumn ? 'value-half' : 'value'"
                                    *ngIf="options.printClosingValueTotalsInSeparateColumn"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cF }}
                                </td>
                                <td
                                    class="text-align-top"
                                    [ngClass]="options.printClosingValueTotalsInSeparateColumn ? 'value-half' : 'value'"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cV }}
                                </td>
                                <td
                                    *ngIf="isFxFormat"
                                    class="text-align-top"
                                    [ngClass]="options.printClosingValueTotalsInSeparateColumn ? 'value-half' : 'value'"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cV2 }}
                                </td>
                                <td
                                    class="ratios text-align-top"
                                    *ngIf="showRatios"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cP }}
                                </td>
                                <td
                                    class="value text-align-top"
                                    *ngIf="!noPreviousData"
                                    [style.background-color]="backgroundColorPY"
                                >
                                    {{ row.pV }}
                                </td>
                                <td
                                    class="value text-align-top"
                                    *ngIf="!noPreviousData && isFxFormat"
                                    [style.background-color]="backgroundColorPY"
                                >
                                    {{ row.pV2 }}
                                </td>
                                <td
                                    class="ratios text-align-top"
                                    *ngIf="!noPreviousData && showRatios"
                                    [style.background-color]="backgroundColorPY"
                                >
                                    {{ row.pP }}
                                </td>
                            </tr>
                        </ng-container>
                        <ng-container
                            *ngIf="
                                row.rowType === 'SubTotal' ||
                                row.rowType === 'GroupTotal' ||
                                row.rowType === 'TableTotal'
                            "
                        >
                            <tr
                                [ngClass]="[
                                    row.rowType === 'SubTotal' && row.disableNumbering
                                        ? 'indent-level-' + row.level
                                        : '',
                                    row.rowType === 'SubTotal' && !row.disableNumbering
                                        ? 'counter-level-' + row.level
                                        : '',
                                    row.rowType === 'TableTotal' ? 'tableTotal' : ''
                                ]"
                                [style.color]="tableFooterColor"
                                class="row-min-height_plus-border-height big-row-min-height_plus-border-height ng-star-inserted"
                            >
                                <td class="title row-min-height black-border-down big-row-min-height text-align-top">
                                    <div [class]="'format-level-' + row.level" class="text-cell">
                                        <span
                                            [ngClass]="
                                                row.rowType != 'SubTotal'
                                                    ? 'indentation-' + row.level
                                                    : 'title-text-' + row.level + ' indentation-' + row.level
                                            "
                                        ></span>
                                        <span> {{ row.t }}</span>
                                    </div>
                                </td>
                                <td class="notes black-border-down big-row-min-height text-align-top" *ngIf="showNotes">
                                    {{ row.r }}
                                </td>
                                <td
                                    [ngClass]="options.printClosingValueTotalsInSeparateColumn ? 'value-half' : 'value'"
                                    class="black-border-down big-row-min-height text-align-top"
                                    *ngIf="options.printClosingValueTotalsInSeparateColumn"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cF }}
                                </td>
                                <td
                                    [ngClass]="options.printClosingValueTotalsInSeparateColumn ? 'value-half' : 'value'"
                                    class="black-border-down big-row-min-height text-align-top"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cV }}
                                </td>
                                <td
                                    *ngIf="isFxFormat"
                                    [ngClass]="options.printClosingValueTotalsInSeparateColumn ? 'value-half' : 'value'"
                                    class="black-border-down big-row-min-height text-align-top"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cV2 }}
                                </td>
                                <td
                                    class="ratios black-border-down big-row-min-height text-align-top"
                                    *ngIf="showRatios"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cP }}
                                </td>

                                <td
                                    class="value black-border-down big-row-min-height text-align-top"
                                    *ngIf="!noPreviousData"
                                    [style.background-color]="backgroundColorPY"
                                >
                                    {{ row.pV }}
                                </td>
                                <td
                                    class="value black-border-down big-row-min-height text-align-top"
                                    *ngIf="!noPreviousData && isFxFormat"
                                    [style.background-color]="backgroundColorPY"
                                >
                                    {{ row.pV2 }}
                                </td>
                                <td
                                    class="ratios black-border-down big-row-min-height text-align-top"
                                    *ngIf="!noPreviousData && showRatios"
                                    [style.background-color]="backgroundColorPY"
                                >
                                    {{ row.pP }}
                                </td>
                            </tr>
                        </ng-container>
                    </ng-container>
                </table>

                <div class="separator-between-tables"></div>
            </div>
        </ng-container>
    </div>
</div>
